<template>
    <div class="wrapper-padding set-wrapper" v-show="value">
        <div v-for="(item,key,index) in set" :key="key">
            <div class="section-title" :class="{mb:index > 0}" v-if="item.type === 'section-title'">{{item.name}}</div>
            <div class="form-item" v-else>
                <span class="label">{{item.name}}</span>
                <div class="content-wrap">
                    <input v-model="item.value" type="number">
                </div>
            </div>
        </div>

        <div class="btns">
            <button @click="handlerOk">保存</button>
            <button class="cancel" @click="handlerCancel">取消</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeSetting",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            setValue: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                set: {}
            }
        },
        watch: {
            setValue: {
                handler(val) {
                    this.set = val
                },
                deep: true,
                immediate: true
            }
        },
        components: {},
        created() {
        },
        methods: {
            handlerOk() {
                this.$emit('on-ok', JSON.parse(JSON.stringify(this.set)))
                this.handlerCancel()
            },
            handlerCancel() {
                this.$emit('input', false)
            }
        },
    }
</script>

<style lang="scss">

</style>
